import React,{useState} from 'react'
import AlertDialog from '../../../../../components/AlertDialog/index.es6'
import { CircularProgress } from '@material-ui/core'
import ButtonInc from '../../../../../shared-ui/ButtonInc'

const DeleteHospital = (props) => {

  if (!props.hospitalToDelete) {
    return ""
  }

  const [showWarning, setShowWarning] = useState(false);

  const cancel = () =>{
    props.resetHospitalToDelete()
  }
  const deleteHospital = () =>{
    setShowWarning(true)
    props.deleteHospital(props.hospitalToDelete);
  }
  const handleHospitalDeletedSuccessfully = () =>{
    props.resetHospitalToDelete()
  }
  const handleHospitalDeletedError = () =>{
    props.resetHospitalToDelete()
  }
  return (
    <>
     <AlertDialog
        custom
        show={props.showDeleteHospitalProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Deleting hospital...</h2>
      </AlertDialog>

      <AlertDialog
        warning
        show={!showWarning && props.hospitalToDelete}
        size="sm"
        title={'Are you sure you want to delete this hospital? '}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { cancel() }}
        onCancel={() => { deleteHospital() }}
        confirmBtnText={'Cancel'}
        showCancel={true}
        showConfirm={true}
        cancelBtnText={'Delete'}
        confirmBtnCssClass
      >
      </AlertDialog>
      <AlertDialog
        success
        show={props.showDeleteHospitalSuccessAlert}
        size="sm"
        title={'Hospital deleted'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleHospitalDeletedSuccessfully() }}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'Delete'}
        confirmBtnCssClass
      >
        <div >
          <ButtonInc onClick={() => { handleHospitalDeletedSuccessfully() }} style={{ background: 'green', }}>OK</ButtonInc>
        </div>
      </AlertDialog>
      <AlertDialog
        show={props.showDeleteHospitalErrorAlert}
        danger
        title={'Error deleting hospital'}
        onConfirm={() => handleHospitalDeletedError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {'Could not delete hospital'}
      </AlertDialog>
    </>
  )
}

export default DeleteHospital